import { render, staticRenderFns } from "./CriacaoRapida.vue?vue&type=template&id=1f16a783"
import script from "./CriacaoRapida.vue?vue&type=script&lang=js"
export * from "./CriacaoRapida.vue?vue&type=script&lang=js"
import style0 from "../assets/criadorBens.styl?vue&type=style&index=0&prod&lang=stylus&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports